import { Platform } from '@angular/cdk/platform';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '@klickdata/core/auth';
import { RecorderTypes } from '@klickdata/core/media';
import { RecorderService, RecordResultsMetaData } from '@klickdata/core/media/src/recorder.service';
import { MobileService } from '@klickdata/core/mobile';
import { takeUntil } from 'rxjs/operators';
import { RecorderBase } from '../recorder-base';

@Component({
    selector: 'app-recorder-audio',
    templateUrl: './recorder-audio.component.html',
    styleUrls: ['./recorder-audio.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecorderAudioComponent extends RecorderBase {
    public recorderConfig: any;
    public recordResultsMetaData: RecordResultsMetaData;
    private isEdge =
        navigator.userAgent.indexOf('Edge') !== -1 &&
        (!!(navigator as any).msSaveOrOpenBlob || !!(navigator as any).msSaveBlob);

    constructor(
        protected snackBar: MatSnackBar,
        protected recordingService: RecorderService,
        protected cdr: ChangeDetectorRef,
        protected auth: AuthService,
        protected mobile: MobileService,
        protected platform: Platform
    ) {
        super(snackBar, recordingService, auth, mobile, platform);
        this.recorderConfig = {
            type: 'audio',
            mimeType: 'audio/mp3',
        };
        this.recordResultsMetaData = {
            title: $localize`KLMS_recorded_audio`,
            extension: 'mp3',
            type: 'audio/mp3',
        };
    }

    public startRecorder(canRecordUnlimited: boolean) {
        if (this.recordingService.recorder) {
            return;
        }
        if (this.isMobile) {
            this.mobile.toggleMenu();
        }

        const microphone = 'microphone' as PermissionName;
        this.haveRequestedPermissions([{ name: microphone }])
            .pipe(takeUntil(this.destroy))
            .subscribe((havePermissions: boolean) => {
                if (!havePermissions) {
                    return;
                } else {
                    this.recordingService.activeRecordingType = RecorderTypes.AUDIO;
                    return new Promise((resolve, reject) => {
                        (<any>navigator).mediaDevices
                            .getUserMedia({
                                audio: this.isEdge
                                    ? true
                                    : {
                                          echoCancellation: false,
                                      },
                            })
                            .then((mic: MediaStream) => {
                                this.recordingService.record(
                                    mic,
                                    this.recorderConfig,
                                    this.recordResultsMetaData,
                                    !canRecordUnlimited
                                );
                                this.showSnackBar();
                                this.cdr.markForCheck();
                                resolve(this.stream);
                            })
                            .catch((error: any) => {
                                this.initPermissionWarningSlider({
                                    body: $localize`Pls give KlickData needed microphone permissions from your browser/system security settings to record and then reload the page`,
                                });
                            });
                    });
                }
            });
    }
}
